/* Conserva el último texto escrito aunque Dawn vuelva a dibujar el carrito. */
(() => {
  const plantilla = document.getElementById('nv3-cart-extras');
  if (!plantilla || window.nv3NotasIniciadas) return;
  window.nv3NotasIniciadas = true;
  const raiz = window.Shopify?.routes?.root || '/';
  let borrador = null;
  let confirmado = null;
  let estado = '';
  let temporizador;
  let guardando = null;
  let permitirEnvio = false;
  const cajas = () => document.querySelectorAll('[data-nv3-cx]');
  const pintar = () => cajas().forEach((caja) => {
    const campo = caja.querySelector('[data-nv3-gift-note]');
    if (borrador !== null && document.activeElement !== campo) campo.value = borrador;
    const aviso = caja.querySelector('[data-nv3-gift-saved]');
    const mensaje = { pendiente: 'Saving…', guardado: 'Saved', error: 'Your note could not be saved. Please try again.' }[estado] || '';
    if (aviso.textContent !== mensaje) aviso.textContent = mensaje;
    aviso.hidden = !mensaje;
    caja.querySelector('[data-nv3-gift-retry]').hidden = estado !== 'error';
  });
  const peticion = async (ruta, opciones = {}) => {
    const respuesta = await fetch(raiz + ruta, { ...opciones, signal: AbortSignal.timeout(10000) });
    if (!respuesta.ok) throw new Error('No se pudo actualizar el carrito');
    return respuesta.json();
  };
  const guardar = () => {
    clearTimeout(temporizador);
    if (guardando) return guardando;
    if (borrador === null || borrador === confirmado) { estado = 'guardado'; pintar(); return Promise.resolve(true); }
    guardando = (async () => {
      try {
        while (borrador !== null && borrador !== confirmado) {
          const texto = borrador;
          estado = 'pendiente'; pintar();
          const carrito = await peticion('cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: texto })
          });
          if ((carrito.note || '') !== texto) throw new Error('La nota no coincide');
          confirmado = texto;
        }
        estado = 'guardado'; pintar();
        return true;
      } catch {
        estado = 'error'; pintar();
        return false;
      } finally { guardando = null; }
    })();
    return guardando;
  };
  const conectar = (caja) => {
    const casilla = caja.querySelector('[data-nv3-gift-toggle]');
    const cuerpo = caja.querySelector('[data-nv3-gift-body]');
    const campo = caja.querySelector('[data-nv3-gift-note]');
    casilla.checked = Boolean(borrador);
    cuerpo.hidden = !casilla.checked;
    casilla.addEventListener('change', () => {
      cuerpo.hidden = !casilla.checked;
      if (casilla.checked) campo.focus();
      else { campo.value = ''; borrador = ''; guardar(); }
    });
    campo.addEventListener('input', () => {
      borrador = campo.value; estado = 'pendiente'; pintar();
      clearTimeout(temporizador); temporizador = setTimeout(guardar, 500);
    });
    caja.querySelector('[data-nv3-gift-retry]').addEventListener('click', guardar);
  };
  const insertar = () => {
    document.querySelectorAll('cart-drawer .cart__ctas, #main-cart-footer .cart__ctas').forEach((destino) => {
      if (destino.parentElement.querySelector('[data-nv3-cx]')) return;
      const caja = plantilla.content.firstElementChild.cloneNode(true);
      destino.insertAdjacentElement('afterend', caja); conectar(caja);
    });
    pintar();
  };
  document.addEventListener('submit', async (evento) => {
    if (evento.submitter?.name !== 'checkout' || permitirEnvio || borrador === null || borrador === confirmado) return;
    evento.preventDefault();
    if (await guardar()) {
      permitirEnvio = true;
      evento.target.requestSubmit(evento.submitter);
      permitirEnvio = false;
    } else document.querySelector('[data-nv3-gift-retry]:not([hidden])')?.focus();
  }, true);
  const arrancar = async () => {
    insertar();
    const observador = new MutationObserver((cambios) => {
      if (cambios.some((cambio) => !cambio.target.closest?.('[data-nv3-cx]'))) insertar();
    });
    document.querySelectorAll('cart-drawer, #main-cart-footer').forEach((elemento) => observador.observe(elemento, { childList: true, subtree: true }));
    try {
      const carrito = await peticion('cart.js');
      confirmado = carrito.note || '';
      if (borrador === null) {
        borrador = confirmado;
        cajas().forEach((caja) => {
          caja.querySelector('[data-nv3-gift-toggle]').checked = Boolean(borrador);
          caja.querySelector('[data-nv3-gift-body]').hidden = !borrador;
        });
      }
      pintar();
    } catch { /* La nota se puede guardar aunque falle la lectura inicial. */ }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
